export const pendenciesFields = ['id', 'text', 'createdAt'];
